/** biome-ignore-all lint/style/useNamingConvention: camel case */
import {useSelector} from 'react-redux';
import {selectIsGuestsFabricGreetingCard} from '~/common/fabric/EventGuests/reducers/guests/selectors';
import {
  PACKAGE_ID_EVITE_PRO,
  PLAN_NAME_GREETING_CARD_SUBSCRIPTION,
  PLAN_NAME_PARTY_PASS,
  PLAN_NAME_PREMIUM_PASS,
  PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION,
  PLAN_NAME_PRO,
} from '~/common/fabric/routes/EventReview/constants';
import {selectSubscriptionPlanName} from '~/common/fabric/User/reducers/user';

const subscriptionTypes = [
  PLAN_NAME_PRO,
  PACKAGE_ID_EVITE_PRO,
  PLAN_NAME_PREMIUM_PASS,
  PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION,
  PLAN_NAME_GREETING_CARD_SUBSCRIPTION,
  PLAN_NAME_PARTY_PASS,
] as const;
const invitationSubscriptionTypes = [
  PLAN_NAME_PRO,
  PACKAGE_ID_EVITE_PRO,
  PLAN_NAME_PREMIUM_PASS,
  PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION,
  PLAN_NAME_PARTY_PASS,
] as const;
export type Subscription = (typeof subscriptionTypes)[number];

/**
 * This hook return false if the user has no subscription plan, or the subscription plan name
 */
export const useUserSubscriptionPlan = (): Subscription | false => {
  const subscriptionPlanName = useSelector(selectSubscriptionPlanName);
  const isGreetingCard = useSelector(selectIsGuestsFabricGreetingCard);
  const types = isGreetingCard ? subscriptionTypes : invitationSubscriptionTypes;
  return types.includes(subscriptionPlanName) ? subscriptionPlanName : false;
};

const SUBSCRIPTION_TYPES = {
  [PLAN_NAME_PRO]: PLAN_NAME_PRO,
  [PACKAGE_ID_EVITE_PRO]: PACKAGE_ID_EVITE_PRO,
  [PLAN_NAME_PREMIUM_PASS]: PLAN_NAME_PREMIUM_PASS,
  [PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION]: PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION,
  [PLAN_NAME_GREETING_CARD_SUBSCRIPTION]: PLAN_NAME_GREETING_CARD_SUBSCRIPTION,
  [PLAN_NAME_PARTY_PASS]: PLAN_NAME_PARTY_PASS,
};

const INVITATION_SUBSCRIPTION_TYPES = {
  pro: PLAN_NAME_PRO,
  evite_pro_yearly: PACKAGE_ID_EVITE_PRO,
  premium_pass: PLAN_NAME_PREMIUM_PASS,
  premium_pass_subscription: PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION,
  party_pass: PLAN_NAME_PARTY_PASS,
};

export const isSubscriptionPlan = (subscriptionPlanName: string, isGreetingCard: boolean) => {
  const types = isGreetingCard ? SUBSCRIPTION_TYPES : INVITATION_SUBSCRIPTION_TYPES;
  return Object.keys(types).includes(subscriptionPlanName);
};
